<template>
  <div style="width:100%;height:100%;" ref="pie">
  </div>
</template>
<script>
  import echarts from 'echarts'
  function setOption(data) {
    let newData = [];
    let i = 0;
    let size = 0;
    let dataMap = new Map();
    for (; i < data.data.length; i++) {
      let oneData = {
        name: data.data[i].name,
        value: data.data[i].value,
        label: {
          normal: {
            show: true,
            position: 'inner'
          }
        },
        labelLine: {
          normal: {
            show: true,
          }
        }
      };
      if (data.isWorksheet) {
        if (oneData.value != 0) {
          oneData.label.normal.position = 'outside';
        }
      } else if (data.isVersionCheck) {
        if (oneData.value != 0 && oneData.value / data.total * 100 < 5) {
          if (!dataMap.get(oneData.value)) {
            dataMap.set(oneData.value, 1);
            oneData.label.normal.position = 'outside';
          } else {
            oneData.label.normal.show = false;
            oneData.labelLine.normal.show = false;
          }
        }
      } else {
        if (oneData.value != 0 && oneData.value / data.total * 100 < 5) {
          oneData.label.normal.position = 'outside';
        }
      }
      if (oneData.value == 0) {
        oneData.label.normal.show = false;
        oneData.labelLine.normal.show = false;
      } else {
        size++;
      }
      newData.push(oneData);
    }
    data.data = newData;
    data.size = size;
    // if(data.reLegend){
    // 	let newLegend = [];
    // 	data.legend.forEach((item,index)=> {
    // 		newLegend.push(item);
    // 		if((index+1)%5==0){
    // 			newLegend.push('\n');
    // 		}
    // 	});
    // 	data.legend=newLegend;
    // }
    var option = {
      backgroundColor: '#fff',
      title: {
        text: data.title ? data.title : '',
        //subtext: data.title.name,
        left: data.titleLeft ? data.titleLeft : '40%',
        top: data.titleTop ? data.titleTop : '1%',
        textStyle: {
          fontSize: data.titleFontSize || 14,
          color: data.titleColor || '#2d2d2d',
          fontWeight: 'normal',
          fontFamily: 'Microsoft YaHei',
          textAlign: "center"
        },
        textAlign: 'center'
      },
      grid: {
        left: '0%', //grid 组件离容器左侧的距离。
        right: '6%', //grid 组件离容器右侧的距离。
        top: '0%',
        bottom: '2%', //grid 组件离容器下侧的距离。
        containLabel: true //grid 区域是否包含坐标轴的刻度标签[ default: false ] 
      },
      tooltip: {
        show: true,
        confine: true,
        trigger: 'item',
        formatter: "{b}: {c} ({d}%)"
      },
      legend: {
        show: data.legendShow == false ? false : true,
        type: data.legendType ? data.legendType : 'scroll',
       // icon: 'emptyCircle',
       icon: 'circle',
       //  orient: 'horizontal',
        orient: data.legendOrient ? data.legendOrient : 'vertical',
        left: data.legendLeft ? data.legendLeft : '68%',
        top: data.legendTop ? data.legendTop : '25%',
        bottom: data.legendBottom ? data.legendBottom : '',
        itemGap: data.legendItemGap ? data.legendItemGap : 10,
        itemWidth: data.legendItemWidth ? data.legendItemWidth : 10,
        itemHeight: data.legendItemHeight ? data.legendItemHeight : 12,
        padding: 12,
        // bottom: '0%',
        data: data.legend,
        textStyle: {
          color: '#566c77'
        }
      },
      series: [{
        type: 'pie',
        selectedMode: 'false',
        silent: true,
        radius: data.radius ? data.radius : ['40%', '70%'],
        center: data.center ? data.center : ['40%', '56%'],
        //color:['#CCCCCC'],
        label: {
          normal: {
            position: 'center',
            formatter: function (params) {
              //let text = data.labelText?data.labelText:'总数';
              //return ['{a|'+params.value+'}','{b|'+text+'}'].join('\n');
              return '{a|' + params.value + '}';
            },
            rich: {
              a: {
                align: 'center',
                color: '#0a97b0',
                fontFamily: 'Microsoft YaHei',
                fontSize: data.aFontSize ? data.aFontSize : 24
              },
              b: {
                align: 'center',
                color: '#566c77',
                fontFamily: 'Microsoft YaHei',
                fontSize: data.bFontSize ? data.bFontSize : 14
              }
            }
          }
        },
        itemStyle: {
          normal: {
            color: 'rgba(0,0,0,0.05)'
          },
        },
        data: [
          { value: data.total }
        ]
      }, {
        type: 'pie',
        startAngle: data.startAngle ? data.startAngle : 90,
        minAngle: data.minAngle ? data.minAngle : 0,
        selectedMode: 'false',
        selectedOffset: 0,
        radius: data.radius ? data.radius : ['40%', '70%'],
        center: data.center ? data.center : ['40%', '56%'],
        color: data.colorList ? data.colorList : ['#ec604d', '#f6a852', '#F8D770', '#95e995', '#C5C5C5', '#F8AE71'],
        itemStyle: {
          borderWidth: data.size != 1 ? 3 : 0,
          borderColor: "#fff"
        },
        label: {
          normal: {
            position: 'inner',
            // formatter: '{d}%',
            formatter: function (params) {
              if (data.nameAndValue) {
                return params.name + " " + params.value;
              } else {
                return params.value;
              }
            },
            textStyle: {
              color: '#57617B',
              fontSize: 12
            }
          }
        },
        labelLine: {
          normal: {
            show: true,
            smooth: data.smooth ? true : false,
            length: data.labelLineLength ? data.labelLineLength : 5,
            length2: 10,
            lineStyle: {
              width: 2
            }
          }
        },
        data: data.data
      }]
    };
    return option
  }
  export default {
    name: 'DgDonut',
    props: ['args'],
    methods: {
      initChart() {
        window.addEventListener('resize', function () {
          this.myChart.resize()
        }.bind(this))
      },
      resize: function () {
        this.myChart.resize()
      },
      reDrawChart: function (args) {
        this.myChart.setOption(setOption(args), false);
        this.myChart.hideLoading();
      }
    },
    mounted: function (el) {
      var container = this.$el;
      this.initChart();
      this.myChart = echarts.init(container);
      let _this = this;
      this.myChart.on('click', function (param) {
        _this.$emit('pieClick', param.data.name);
      });
      this.myChart.showLoading({
        text: '数据正在加载...',
        textStyle: {
          fontSize: 16,
          color: '#444'
        },
        effectOption: { backgroundColor: 'rgba(0,0,0,0)' }
      });
    },
    watch: {
      updateFlag: function (val) {
        setTimeout(() => {
          this.myChart.resize()
        }, 150);
      }
    }
  }
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/echarts/dgDonutChart.vue